import { numberToPrettyString } from '@cian/utils';

import { IAreaPart } from 'shared/offer';

export const getIsRent = (paymentPeriod?: string | null): boolean => {
  return paymentPeriod === 'annual' || paymentPeriod === 'monthly';
};

export const prepareFloorsRange = ({ floorFrom, floorTo }: IPrepareFloorsRangeArgs) => {
  if (floorTo === floorFrom) {
    return `${floorFrom} этаж`;
  }

  if (floorTo === floorFrom + 1) {
    return `${floorFrom} и ${floorTo} этаж`;
  }

  return `${floorFrom} \u2013 ${floorTo} этаж`;
};

export const getFormattedFloor = (areaPart: IAreaPart) => {
  const { floorFrom, floorTo } = areaPart;

  if (!floorFrom && !floorTo) {
    return '';
  }

  if (floorFrom && floorTo) {
    return prepareFloorsRange({ floorFrom, floorTo });
  }

  const floor = (floorFrom || floorTo) as number;

  return prepareFloorsRange({ floorFrom: floor, floorTo: floor });
};

interface IPrepareFloorsRangeArgs {
  floorFrom: number;
  floorTo: number;
}

export const getFormattedArea = (partArea?: number) => {
  if (partArea === undefined) {
    return '';
  }

  const area = numberToPrettyString(partArea);

  return `${area} м²`;
};

export const getPrice = (isRent?: boolean, part?: IAreaPart): string => {
  if (part && part.price) {
    const { price } = part;

    return `${numberToPrettyString(price)} ₽${isRent ? '/мес.' : ''}`;
  }

  return '';
};

export const getMinAreaPrice = (areas?: IAreaPart[], paymentPeriod?: string | null): string => {
  if (areas === undefined) {
    return '';
  }

  const sortedAreas = areas.sort((a, b) => (a.price && b.price ? a.price - b.price : 0));

  const minArea = sortedAreas[0];
  const isRent = getIsRent(paymentPeriod || '');

  return getPrice(isRent, minArea);
};
